import React from "react";
import Lottie from "react-lottie";
// If there are images, use the converted json (index.js)
import animationData from "./lottie/storyboard5";
// If there are NO images, just load the json directly
// import animationData from "./lottie/storyboard5/data.json";
import image from "./images/capabilities-phone-profile.png";
import ArrowButton from "./ArrowButton";
import "./Capabilities2BiometricsScreen.scss";
import { t } from "i18next";

function Capabilities2BiometricsScreen() {
  return (
    <div className="fill-absolute">
      <div
        className="container full-height row-reverse-mobile"
        style={{ paddingBottom: 50 }}
      >
        <div className="full-height padding flex full-center lottie-container">
          <Lottie
            options={{
              animationData,
            }}
            // height={400}
            // width={400}
          />
        </div>
        {/* <div style={{flex:0.25}}/> */}
        <div className="full-height padding flex vertical-center mobile-nav-padding">
          <h2 className="green-header">
            {t("Capability2.title")} &amp; {t("Capability2.title2")}
          </h2>
          <p>{t("Capability2.section1")}</p>
          <p>{t("Capability2.section2")}</p>
          <p>{t("Capability2.section3")}</p>
        </div>
      </div>
      <div className="buttons-container">
        <ArrowButton to="/capabilities-ai" side="left"></ArrowButton>
        <ArrowButton
          to="/capabilities-conversational-ai"
          side="right"
        ></ArrowButton>
      </div>
    </div>
  );
}

export default Capabilities2BiometricsScreen;
